import { areBoundingBoxesEqual } from '~/_shared/utils/latLng/latLng.helpers';
import type { LastBounds } from './mapComponent.state';

export const areLastBoundsEqual = (a: LastBounds | null, b: LastBounds | null): boolean => {
  if (a === b) {
    return true;
  }
  if (!a || !b) {
    return false;
  }
  if (a.zoomLevel !== b.zoomLevel) {
    return false;
  }
  return areBoundingBoxesEqual(a.bounds, b.bounds);
};
